export default function beautifyNumberFormatter(num) {
  if (! /^[0-9]*\.?[0-9]*$/.test(num)) {
    return num
  }

  const sign = Math.sign(num)
  const positiveNumber = Math.abs(num)
  let formatted

  if (positiveNumber > 999999) {
    formatted = `${ sign * Math.floor((positiveNumber / 1000000)) }M+`
  } else if (positiveNumber > 99999) {
    formatted = `${ sign * Math.floor((positiveNumber / 100000)) }00K+`
  } else if (positiveNumber > 9999) {
    formatted = `${ sign * Math.floor((positiveNumber / 10000)) }0K+`
  } else {
    formatted = sign * positiveNumber
  }

  return formatted
}
